export const getCOSFormatDirectoryFromKey = (key) => {
    let cosDirectory = '';
    if (key.includes('%__parentDir__%/')) {
        cosDirectory = key.replace('%__parentDir__%/', '');
    } else if (key.includes('%__parentDir__%')) {
        cosDirectory = key.replace('%__parentDir__%', '');
    } else {
        cosDirectory = key;
    }
    return cosDirectory;
};

export const prefixFileSeparator = (fileKey) => {
    const splitString = fileKey.split('/');
    return {
        loc_array: splitString,
        objectName: splitString.slice(-1)[0]
    };
};

export const mapFinder = (fileMap, fileKey) => {
    if (!fileKey || !fileMap) return null;

    const splitString = fileKey.split('/').filter(Boolean);
    let currentMap = fileMap;

    for (const folder of splitString) {
        currentMap = currentMap.get(folder);
        if (!currentMap) return null;
    }

    return currentMap;
};

export const parentFolderObjectSplitter = (key) => {
    const splitString = key.split('/');
    const parentDir = splitString.slice(0,-1).join('/');
    const objectName = splitString.slice(-1)[0];
    return {
        parentDir,
        objectName
    };
};
